import React, { useState, useRef, useEffect } from 'react';
// CSS STYLES
import styles from '../../styles/Components/Shared/SearchDropdown.module.css';
// ICONS
import { IoIosArrowDown  } from "react-icons/io"


const SearchDropdown  = ({ 
    options, 
    handleSelect, 
    placeholder, 
    selection, 
    nameIsValue, 
    handleSearch, 
    emptyOption, 
    blueBorder, 
    darkText, 
    clear, 
    disabled, 
    maxHeight, 
    clearOnSelect,
    dropDownAbove,
    disableFilterOptions, 
    enableCreateOption,
    handleCreateOption,
    returnData,
    allowClearSelected,
    filterFunction,
 }) => { 

    const [optionToCreate, setOptionToCreate] = useState(null)
    const [searchTerm, setSearchTerm] = useState('')
    const [selected, setSelected] = useState(null)
    const [searchIndex, setSearchIndex] = useState(0)
    const [close, setClose] = useState(0)
    const searchRef = useRef(null)
    const inputRef = useRef(null)
    
    const handleClick = (option) => {
        if (selection && selection === (nameIsValue ? option.name : option.value)) {
            return setClose(close + 1)
        }

        if (!clearOnSelect) {
            setSearchTerm(option.name)
        } else {
            setSearchTerm('')
        }

        handleSelect(returnData ? option.data : nameIsValue ? option.name : option.value, option.name)

        setClose(close + 1)
    }

    const handleKeyPress = (e) => {
        setSelected(null)
        
        if (e?.key === 'ArrowDown' && searchIndex < options.filter(e => filterFunction? filterFunction(e, searchTerm) : e?.name?.toLowerCase()?.includes(searchTerm.toLowerCase())).length - 1) {
            if (searchRef.current) {
                searchRef.current.scrollIntoView()

            }
            return setSearchIndex(searchIndex + 1)
        } else if (e?.key === 'ArrowUp' && searchIndex > 0) {
            if (searchRef.current) {
                searchRef.current.scrollIntoView({ block: 'center'})
            }

            return setSearchIndex(searchIndex - 1)
        } else if (e?.key !== 'Tab') {
            return
        }
        
        if (searchRef.current && searchRef.current.textContent) {
            const selectedValue = nameIsValue ? searchRef.current.textContent : searchRef.current.id
            setSearchTerm(searchRef.current.textContent)
            handleSelect(selectedValue, searchRef.current.textContent)
        }
    }

    const handleClear = () => {
        setSearchTerm('')

        if (clear) {
            clear()
        }
    }

    // useEffect(() => {
    //     if (options.length === 0 && !searchTerm && handleSearch && selection ){
    //         handleSearch(selection)
    //     }
    // }, [handleSearch, selection])

    useEffect(() => {
        
        if (selection) {
            const found = options?.find(e => nameIsValue ? e.name === selection :  e.value === selection)

            if (found) {
                setSelected(found.name)
                setSearchTerm('')
            } 


        } else if (selection === null) {
            setSelected('')
        }
    }, [selection, options])

    const handleSearchChange = (e) => {
        if (handleSearch) {
            handleSearch(e.target.value)
        }     
        setSearchTerm(e.target.value);
        setSearchIndex(0);

        if (enableCreateOption) {
            let newOption = e.target.value
            const newOptionObj = { name: newOption, value: newOption, isNew: true }
            setOptionToCreate(newOptionObj)

        }
    }


    const handleCreateNewOption = (option) => {
        if (handleCreateOption) {
            handleCreateOption(option)
        }
        setSearchTerm('')
        setOptionToCreate(null)
    }
    

    return  (
        <div  >
            <input 
                 className={`${blueBorder ? 'input' : 'input_basic'} ${styles.search_dropdown} ${darkText ? styles.dark_text : ''}`} 
                type='text'
                name='searchTerm'
                disabled={disabled ? true : false}
                placeholder={selected ? selected : placeholder ? placeholder : `Select`}
                autoComplete='off'
                value={searchTerm}
                onChange={(e) => handleSearchChange(e)}
                onKeyDown={(e) => handleKeyPress(e) }
                ref={inputRef}
            />
                <div 
                    className={`${styles.search_dropdown_container} ${dropDownAbove ? styles.search_dropdown_container_above : ''}`} 
                    key={close} style={maxHeight ? { maxHeight } : {}}
                >
                    <>
                        {
                            enableCreateOption && optionToCreate ? (
                                <p onClick={() => handleCreateNewOption(optionToCreate)}>{`Create - "${optionToCreate.name}"`}</p>
                            ) : (null)
                        }

                        {options?.length > 0 && options.filter(e => filterFunction ? filterFunction(e, searchTerm) : disableFilterOptions ? e : e?.name?.toLowerCase()?.includes(searchTerm.toLowerCase()))?.length > 0 ?
                            options.filter(e => filterFunction ? filterFunction(e, searchTerm) : disableFilterOptions ? e : e?.name?.toLowerCase()?.includes(searchTerm.toLowerCase())).map((option, i) =>  (
                                <p key={`option-${i}`} id={option.name} onClick={() => handleClick(option)} ref={searchTerm && i === searchIndex ? searchRef : null}  className={searchTerm && i === searchIndex ? styles.selected : ''}>{option.name}</p>
                            ))
                        : emptyOption ? 
                            <p className={styles.empty_option}>{emptyOption}</p>
                        : null}
                    
                    </>
                </div>
                {searchTerm || (allowClearSelected && selection) ? 
                    <button className={styles.clear_search} onClick={() => handleClear()}>x</button>
                : disabled ? null : <p className={styles.dropdown_arrow} onClick={() => inputRef.current?.focus()}><IoIosArrowDown size={20} /></p>}

        </div>
    ) 
}
export default SearchDropdown;



// import React, { useState, useRef, useEffect } from 'react';
// import { IoIosArrowDown  } from "react-icons/io"
// import styles from '../../styles/Components/Shared/SearchDropdown.module.css';


// const SearchDropdown  = ({ 
//     options, 
//     handleSelect, 
//     placeholder, 
//     selection, 
//     nameIsValue, 
//     handleSearch, 
//     emptyOption, 
//     blueBorder, 
//     darkText, 
//     clear, 
//     disabled, 
//     disableFilter, 
//     maxHeight, 
//     clearOnSelect,
//     dropDownAbove
//  }) => { 
//     const [searchTerm, setSearchTerm] = useState('')
//     const [selected, setSelected] = useState(null)
//     const [searchIndex, setSearchIndex] = useState(0)
//     const [close, setClose] = useState(0)
//     const searchRef = useRef(null)
//     const inputRef = useRef(null)
    
//     const handleClick = (option) => {
//         if (selection && selection === (nameIsValue ? option.name : option.value)) {
//             return setClose(close + 1)
//         }

//         if (!clearOnSelect) {
//             setSearchTerm(option.name)
//         } else {
//             setSearchTerm('')
//         }

//         handleSelect(nameIsValue ? option.name : option.value, option.name)
//         setClose(close + 1)
//     }

//     const handleKeyPress = (e) => {
//         setSelected(null)
        
//         if (e?.key === 'ArrowDown' && searchIndex < options.filter(e => e?.name?.toLowerCase()?.includes(searchTerm.toLowerCase())).length - 1) {
//             if (searchRef.current) {
//                 searchRef.current.scrollIntoView()

//             }
//             return setSearchIndex(searchIndex + 1)
//         } else if (e?.key === 'ArrowUp' && searchIndex > 0) {
//             if (searchRef.current) {
//                 searchRef.current.scrollIntoView({ block: 'center'})
//             }

//             return setSearchIndex(searchIndex - 1)
//         } else if (e?.key !== 'Tab') {
//             return
//         }
        
//         if (searchRef.current && searchRef.current.textContent) {
//             const selectedValue = nameIsValue ? searchRef.current.textContent : searchRef.current.id
//             setSearchTerm(searchRef.current.textContent)
//             handleSelect(selectedValue, searchRef.current.textContent)
//         }
//     }

//     const handleClear = () => {
//         setSearchTerm('')

//         if (clear) {
//             clear()
//         }
//     }

//     useEffect(() => {
        
//         if (selection) {
//             const found = options?.find(e => nameIsValue ? e.name === selection :  e.value == selection)
   
//             if (found) {
//                 setSelected(found.name)
//                 setSearchTerm('')

//             }
//         } else if (selection === null) {
//             setSelected('')
//         }
//     }, [selection, options])
    
//     const handleSearchChange = (e) => {
//         if (handleSearch) {
//             handleSearch(e.target.value)
//         }     
//         setSearchTerm(e.target.value);
//         setSearchIndex(0);
//     }

//     return  (
//         <div  >
//             <input 
//                 className={`${blueBorder ? 'input' : 'input_basic'} ${styles.search_dropdown} ${darkText ? styles.dark_text : ''}`} 
//                 type='text'
//                 name='searchTerm'
//                 disabled={disabled ? true : false}
//                 placeholder={selected ? selected : placeholder ? placeholder : `Select`}
//                 autoComplete='off'
//                 value={searchTerm}
//                 onChange={(e) => handleSearchChange(e)}
//                 onKeyDown={(e) => handleKeyPress(e) }
//                 ref={inputRef}
//                 />
//                 <div className={`${styles.search_dropdown_container} ${dropDownAbove ? styles.search_dropdown_container_above : ''}`} key={close} style={maxHeight ? { maxHeight } : {}}>
//                     {options?.length > 0 && options.filter(e => disableFilter ? e : e?.name?.toLowerCase()?.includes(searchTerm.toLowerCase()))?.length > 0 ?
//                         options.filter(e => disableFilter ? e : e?.name?.toLowerCase()?.includes(searchTerm.toLowerCase())).map((option, i) =>  (
//                             <p key={`option-${i}`} id={option.name} onClick={() => handleClick(option)} ref={searchTerm && i === searchIndex ? searchRef : null}  className={searchTerm && i === searchIndex ? styles.selected : ''}>{option.name}</p>
//                         ))
//                     : emptyOption ? 
//                         <p className={styles.empty_option}>{emptyOption}</p>
//                     : null}

//                 </div>
//                 {searchTerm ? 
//                     <button className={styles.clear_search} onClick={() => handleClear()}>x</button>
//                 : disabled ? null : <p className={styles.dropdown_arrow} onClick={() => inputRef.current?.focus()}><IoIosArrowDown size={20} /></p>}
//         </div>
//     ) 
// }
// export default SearchDropdown;